import React from 'react';
import { Text } from '@blueprint/text';
import { Wrapper, Container } from './Badge.styles';
import { Icon } from '@blueprint/ui';

var PremiumBadge = function PremiumBadge() {
  return React.createElement(Container, null, React.createElement(Icon, {
    iconId: "star",
    size: "small",
    color: "icon-light"
  }), React.createElement(Text, {
    size: "small"
  }, "PREMIUM"));
};

var PremiumListingBadge = function PremiumListingBadge() {
  return React.createElement(Container, null, React.createElement(Icon, {
    iconId: "star",
    size: "small",
    color: "icon-light"
  }), React.createElement(Text, {
    size: "small"
  }, "PREMIUM LISTING"));
};

var JustAddedBadge = function JustAddedBadge() {
  return React.createElement(Container, null, React.createElement(Text, {
    size: "small"
  }, "JUST ADDED"));
};

var SavedBadge = function SavedBadge() {
  return React.createElement(Container, null, React.createElement(Icon, {
    iconId: "save_filled",
    size: "small"
  }), React.createElement(Text, {
    size: "small"
  }, "SAVED"));
};

var FeaturedBadge = function FeaturedBadge() {
  return React.createElement(Container, null, React.createElement(Text, {
    size: "small"
  }, "FEATURED"));
};

export var getBadge = function getBadge(variant) {
  switch (variant) {
    case 'premium':
      return PremiumBadge();

    case 'premiumListing':
      return PremiumListingBadge();

    case 'justAdded':
      return JustAddedBadge();

    case 'saved':
      return SavedBadge();

    case 'featured':
      return FeaturedBadge();
  }
};

var Badge = function Badge(props) {
  var variant = props.variant;
  return React.createElement(React.Fragment, null, React.createElement(Wrapper, props, getBadge(variant)));
};

export { Badge };
//# sourceMappingURL=Badge.js.map